import React from "react";
import Heading from "@insightfulscience/atomic-react/Heading";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import Link from "@insightfulscience/atomic-react/Link";
import routes from "../routes";

const Error500 = () => (
	<>
		<Heading
			Tag="h1"
			sx={{ fontSize: "xl", fontColor: "3", textAlign: "center" }}
			spacing={{ mb: 6 }}
		>
			Something went wrong
		</Heading>
		<Paragraph sx={{ fontSize: "s", textAlign: "center" }}>
			We’re sorry. Something has gone wrong with the application.
			<br />
			<br />
			Please try again later or{" "}
			<Link sx={{ fontSize: "s" }} href={routes.external.contactUs}>
				contact us
			</Link>{" "}
			for further assistance.
		</Paragraph>
	</>
);

export default Error500;
